import { tempOLoading } from '../config'
import { useAutoQuery } from '@/utils/useAutoQuery'
import { generateExportCondition } from '@/utils/exportUtils.js'

const departmentField = Symbol('departmentField')
const hasDepartmentField = (data) => data && data[departmentField] === true

export default {
  props: ['configData', 'activeAutoQuery'],
  data() {
    const { formData = {}, tableData = {} } = this.configData
    return {
      formData,
      tableData,
      pagination: {},
      oLoading: {},
    }
  },
  computed: {
    showForm() {
      const { formData = {} } = this.configData
      return Object.keys(formData).length > 0
    },
    showDepartment() {
      const { isShowDepartment = true } = this.configData
      return isShowDepartment
    },
    showAllDepartment() {
      const { isShowAllDepartment = false } = this.configData
      return isShowAllDepartment
    },
  },
  provide() {
    return {
      activeAutoQuery: this.activeAutoQuery,
      updateOptions: this.updateOptions,
    }
  },
  methods: {
    // 搜索查询（pageNum:1)
    paginationChange(payload) {
      // 模版展示搜索表单
      this.$refs.baseTable.setIsSearch(true)
      this.$refs.baseTable.paginationChange(payload)
    },

    // 表格分页查询(表单有内容);type为业务组件传递参数(form为第一页+搜索参数,table：当前页+搜索参数)
    searchForm(type) {
      const { showForm } = this
      // 搜索参数汇总
      const { pagination, sorter } = this.$refs.baseTable
      const searchData = Object.assign(
        {},
        { pagination },
        sorter ? { sorter } : {},
      )
      if (showForm) {
        this.$refs.searchForm.setPagination(searchData)
        this.$refs.searchForm.search(type || 'table')
      } else {
        // 模版不展示搜索表单
        this.$refs.baseTable.setIsSearch(false)
        this.$refs.baseTable.paginationChange(searchData)
      }
    },

    // 重置搜索表单方法
    reset() {
      this.$refs.searchForm.reset()
    },

    // 设置form表单loading
    setFormLoading(flag) {
      const { showForm } = this
      if (showForm) this.$refs.searchForm.loading.search = flag
    },

    // 校验参数
    validateParams(params) {
      let errorMsg = ''
      const { keys } = params
      const { data } = params
      for (const [key, value] of Object.entries(keys)) {
        if (!value) errorMsg += ` ${key}`
      }
      if (typeof data === 'undefined') errorMsg += ' data'
      return errorMsg
    },

    // 设置模版数据formData/list/elConfig/list值
    /**
     * key: formData/list/itemConfig/prop值,必传参数
     * elConfigKeys:elConfig的某一属性或是isShow属性
     * elConfigKey:elConfigKeys对象的某一属性，必传参数,
     * data：接口数据或是本地维护的数据，必传参数
     */
    setItemData({ elConfigKeys = null, elConfigKey = null, key, data }) {
      if (this.showForm) {
        const params = {
          keys: { key },
          data,
        }
        // 错误参数
        const errorKeys = this.validateParams(params)
        if (errorKeys.trim().length > 0) return
        // 数据异常处理
        if (Object.prototype.toString.call(data) === '[object Null]') return
        const tempList = this.configData.formData.list
        const formItem =
          tempList && tempList.find((item) => item.itemConfig.prop === key)

        const val3 = elConfigKey === 'isShow' ? formItem : formItem?.elConfig

        const val2 =
            elConfigKey === 'list'
              ? formItem?.elConfig?.options || formItem?.elConfig
              : val3

        const val1 = elConfigKey ? val2 : null

        const formItemKey = elConfigKeys ? formItem?.elConfig[elConfigKeys] : val1

        if (formItem && formItemKey) {
          this.$set(formItemKey, elConfigKey, data)
          if (elConfigKey === 'value' && this.configData.formData?.formProps?.model) {
            this.configData.formData.formProps.model[key] = data
          }
        }
      }
    },

    // 获取base-list-management中base-form、base-table、search-form最终的ref
    /**
     * formRef：通过formData/formProps传入的ref，默认值form
     * formItemRef: 通过formData/list/itemConfig传入的ref，默认值baseFormItem
     * type: 包含form和table两种，默认为form
     * commonTableRef：通过tableData配置信息传入的ref
     * 用到那种场景传入对应的ref即可
     */
    getRefs({ type = 'form', formRef, formItemRef, commonTableRef }) {
      const baseFormRef = this.$refs.searchForm.$refs.searchForm

      const val2 = commonTableRef
        ? this.$refs.baseTable.$refs.baseTableRef
        : this.$refs.baseTable


      const val3 = formItemRef
        ? baseFormRef.$refs.baseFormItem.$refs[formItemRef][0].$refs[
          formItemRef
        ]
        : baseFormRef
      const val1 = formRef
        ? baseFormRef.$refs[formRef || 'form']
        : val3
      const ref = type === 'form' ? val1 : val2
      return ref
    },
    // 获取当前请求参数
    getParams() {
      return this.$refs.searchForm.getSearchParams()
    },

    /**
     * 1. 给form表单添加所属部门筛选字段
     * 2. 给table添加所属部门列
     */
    addDeptField() {
      // 所属部门筛选项
      const formItem = {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          defaultValue: [],
          isAll: this.showAllDepartment,
          options: {
            list: [],
            value: 'id',
            label: 'name',
          },
          labelKey: 'deptIdList',
        },
        render: 'DeptTree',
        [departmentField]: true,
      }

      // 所属部门字段
      const tableColumn = {
        name: 'deptName',
        columnProps: {
          prop: 'deptName',
          label: '所属部门',
          width: 150,
        },
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
        [departmentField]: true,
      }
      const formItems = this.formData?.list || []
      const tableColumns = this.tableData?.columns || []

      if (!formItems.find(hasDepartmentField)) {
        this.formData?.list?.push(formItem)
      }

      if (!tableColumns.find(hasDepartmentField)) {
        this.tableData?.columns?.push(tableColumn)
      }
    },

    removeDepartmentField() {
      const formItems = this.formData?.list || []
      const tableColumns = this.tableData?.columns || []
      const formItemIndex = formItems.findIndex(hasDepartmentField)
      const tableColumnIndex = tableColumns.findIndex(hasDepartmentField)

      if (formItemIndex !== -1) {
        this.formData.list.splice(formItemIndex, 1)
      }

      if (tableColumnIndex !== -1) {
        this.tableData.columns.splice(tableColumnIndex, 1)
      }
    },
    // 更新可选项，TODO：目前仅部门选择器用，暂时改为更新list，后续需要改为所有筛选项且直接返回文案
    updateOptions(key, list) {
      const current = this.formData.list.find((item) => item.itemConfig.prop === key)
      if (current) {
        current.elConfig.options.list = list
      }
    },
    // 获取筛选项的文案
    getSelectedLabels() {
      return this.formData.list.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.getParams()[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
    },
  },
  created() {
    // 加上车务特有的业务逻辑
    if (this.showDepartment) {
      this.addDeptField()
    }
  },
  mounted() {
    const planId = this.$route?.query?.planId
    const { model } = this.configData.formData.formProps
    if (Object.prototype.hasOwnProperty.call(model, 'planId') && planId) {
      this.configData.formData.formProps.model.planId = Number(planId)
    }
    // 如果开启自动查询，则将url中参数赋给model
    if (this.activeAutoQuery) {
      const aq = useAutoQuery()
      const filter = {}
      for (const key in aq.f) {
        if (Object.hasOwnProperty.call(aq.f, key)) {
          filter[key] = aq.f[key]
        }
      }
      this.$set(this.configData.formData.formProps, 'model', {
        ...model,
        ...filter,
      })
    }
    this.oLoading = Object.assign(tempOLoading, this.$refs.baseTable.oLoading)
    this.$nextTick(() => {
      this.searchForm()
      this.$emit('component-mounted')
    })
  },
  beforeDestroy() {
    if (this.showDepartment) {
      this.removeDepartmentField()
    }
  },
}
